var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "block",
    { staticStyle: { "padding-bottom": "60px" } },
    [
      _c("template", { slot: "header" }, [_vm._v("Alerta Manual")]),
      _vm._v(" "),
      _c("div", { staticClass: "alert-type" }, [
        _c("h4", { staticClass: "is-uppercase" }, [_vm._v("Tipo de Alerta")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "risk-factors" },
          _vm._l(_vm.riskFactors, function(r) {
            return _c(
              "div",
              { key: r.code, staticClass: "risk-factors-item" },
              [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: r.on,
                        expression: "r.on"
                      }
                    ],
                    staticClass: "risk-factor-check",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(r.on)
                        ? _vm._i(r.on, null) > -1
                        : r.on
                    },
                    on: {
                      change: function($event) {
                        var $$a = r.on,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && _vm.$set(r, "on", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                r,
                                "on",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(r, "on", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "risk-factor-name is-lowercase" }, [
                    _vm._v(_vm._s(r.name))
                  ])
                ])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert-details" }, [
        _c("h4", { staticClass: "is-uppercase" }, [_vm._v("DETALLES")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.details,
              expression: "details"
            }
          ],
          attrs: {
            placeholder: "Por favor especificar problema del estudiante"
          },
          domProps: { value: _vm.details },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.details = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "responsible" }, [
        _c("h4", { staticClass: "is-uppercase" }, [_vm._v("Remitir alerta a")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "multiselect-container" },
          [
            _c("multiselect", {
              attrs: { "options-list": _vm.possibleResponsibleUsersForAlert },
              model: {
                value: _vm.selectedResponsible,
                callback: function($$v) {
                  _vm.selectedResponsible = $$v
                },
                expression: "selectedResponsible"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.messageForResponsible,
              expression: "messageForResponsible"
            }
          ],
          staticClass: "responsible-message",
          staticStyle: { "margin-top": "10px" },
          attrs: {
            type: "text",
            max: "140",
            placeholder:
              "Comentario personal para responsable de tarea (máx. 140 caracteres)."
          },
          domProps: { value: _vm.messageForResponsible },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.messageForResponsible = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary add",
            class: { "is-loading": _vm.loading },
            attrs: { disabled: !_vm.isValid },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      Remitir\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-outlined cancel",
            attrs: { disabled: _vm.loading },
            on: { click: _vm.cancel }
          },
          [_vm._v("\n      Cancelar\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }